import { formatDate, isRTL } from "@common/helpers/i18n";

export class ProcessData {
  static genericMetric(data: { [date: string]: number | null }) {
    return {
      data: Object.values(data).map((item) => item || 0),
      label: ProcessData.dateLabels(data),
    };
  }

  static dateLabels(data: { [date: string]: any }) {
    return Object.keys(data).map((date) =>
      formatDate(
        date,
        formatDate(date, isRTL ? "jYYYY/jMM/jDD" : "YYYY/MM/DD"),
      ),
    );
  }
}
